/* eslint-disable camelcase */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Grid, Tooltip } from '../../../canvasComponents/index';
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl';
import { v4 } from 'uuid';
import CustomWhatAreTheInjuriesSettings from './CustomWhatAreTheInjuries.settingsForm';
import './CustomWhatAreTheInjuries.scss';
import { getTypelist, selectBonesBrokenOptions, selectAllInjuriesApplyOptions, followingApplyOptions, wereAnyOfTheFollowingItemsDamagedOptions } from './CheckboxesOptions';
import FileUpload from '../utils/FileUpload/FileUpload';
import FatalityPopUp from '../../../components/FatalityPopup/FatalityPopUp';
import getLocalParams from '../localizationCustoms';
import messages from '../utils/FileUpload/messages';
import FormioErrorHandler from '../../../components/FormioErrorHandler/FormioErrorPopup';

const CustomWhatAreTheInjuries = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      data: props.data,
      thePolicy: JSON.parse(window.sessionStorage.getItem('thePolicy')),
      formErrors: props.formErrors,
      hasTriggeredError: false,
      fatalityModal: { opened: false, num: 0 },
    };
    this.errorHandler = this.errorHandler.bind(this);
    this.setCheckboxValue = this.setCheckboxValue.bind(this);
    this.checked = this.checked.bind(this);
    this.showDynamicField = this.showDynamicField.bind(this);
    this.dragAndDropHandler = this.dragAndDropHandler.bind(this);
    this.getClaimType = this.getClaimType.bind(this);
    this.isABOnly = this.isABOnly.bind(this);
  }

  componentDidMount() {
    const { data, value } = this.state;
    const { onChange, form } = this.props || null;

    form?.on('error', this.errorHandler);

    if (typeof value === 'undefined' || value === null || value?.whatAreTheInjuriesInfo?.length === 0) {
      const temp = [];

      if (!this.isABOnly() && data?.driverIsInjured?.value && data?.whoDrivingVehicle?.value?.name !== 'Unoccupied') {
        if (data?.whoDrivingVehicle?.value?.name !== 'Driver not listed') {
          temp.push({ firstName: data.whoDrivingVehicle.value.firstName, lastName: data.whoDrivingVehicle.value.lastName, injuredPolicySystemId: data.whoDrivingVehicle.value.policySystemId, injuredId: data.whoDrivingVehicle.value.id || '' });
        } else if ((data?.driver?.firstName?.value) || (data?.driver?.lastName?.value)) {
          temp.push({ firstName: data.driver.firstName.value, lastName: data.driver.lastName.value, injuredTemporaryId: data.driver.temporaryId, injuredId: data.driver.id || '' });
        } else {
          temp.push({ firstName: '', lastName: '', injuredTemporaryId: data.driver.temporaryId, injuredId: data.driver.id || '' });
        }
      }
      if (data?.passengers) {
        for (let i = 0; i < data.passengers.addPassengerInfo.length; i += 1) {
          const isInjured = data.passengers.addPassengerInfo[i].selected && data.passengers.addPassengerInfo[i].isInjured.value;

          if (isInjured && data.passengers.addPassengerInfo[i].name.value !== 'No passenger') {
            if (Object.prototype.hasOwnProperty.call(data.passengers.addPassengerInfo[i], 'policySystemId')) {
              temp.push({ firstName: data.passengers.addPassengerInfo[i].firstName, lastName: data.passengers.addPassengerInfo[i].lastName, injuredPolicySystemId: data.passengers.addPassengerInfo[i].policySystemId, injuredId: data.passengers.addPassengerInfo[i].id || '' });
            } else {
              temp.push({ firstName: data.passengers.addPassengerInfo[i].firstName, lastName: data.passengers.addPassengerInfo[i].lastName, injuredTemporaryId: data.passengers.addPassengerInfo[i].temporaryId, injuredId: data.passengers.addPassengerInfo[i].id || '' });
            }
          }
        }
      }
      const transformedArray = temp.map((t) => ({
        ...t,
        id: '',
        temporaryId: `tempId-${v4()}`,
        selectAllInjuriesApply: { selectedValues: [], review: t.firstName !== '' && t.lastName !== '' ? { label: `${t.firstName} ${t.lastName}`, typelist: getTypelist('selectAllInjuriesApply') } : { label: 'Driver', typelist: getTypelist('selectAllInjuriesApply') } },
        selectBonesBroken: { selectedValues: [], review: { label: 'Broken bones', typelist: getTypelist('selectBonesBroken') } },
        followingApply: { selectedValues: [], review: { label: 'Impact', typelist: getTypelist('followingApply') } },
        wereAnyOfTheFollowingItemsDamaged: { selectedValues: [], review: { label: 'Damaged items', typelist: getTypelist('wereAnyOfTheFollowingItemsDamaged') } } }));

      const num = transformedArray ? transformedArray.length : 0;
      const errors = Array(num).fill({ selectAllInjuriesApply: false, selectBonesBroken: false, followingApply: false, file_damagesPictures: false });

      this.setState({ value: { whatAreTheInjuriesInfo: transformedArray }, formErrors: errors }, () => {
      // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else {
      const injuredPassengers = [];
      const notInjuredPassengers = [];

      if (!this.isABOnly() && data?.driverIsInjured?.value && data?.whoDrivingVehicle?.value?.name !== 'Unoccupied') {
        if (data?.whoDrivingVehicle?.value?.name !== 'Driver not listed') {
          injuredPassengers.push({ firstName: data.whoDrivingVehicle?.value?.firstName, lastName: data.whoDrivingVehicle?.value?.lastName, injuredPolicySystemId: data.whoDrivingVehicle?.value?.policySystemId, injuredId: data.whoDrivingVehicle?.value?.id || '', id: '', temporaryId: `tempId-${v4()}` });
        } else if ((data?.driver?.firstName?.value) || (data?.driver?.lastName?.value)) {
          injuredPassengers.push({ firstName: data.driver?.firstName?.value, lastName: data.driver?.lastName?.value, injuredTemporaryId: data.driver?.temporaryId, injuredId: data.driver?.id || '', id: '', temporaryId: `tempId-${v4()}` });
        } else {
          injuredPassengers.push({ firstName: '', lastName: '', injuredTemporaryId: data.driver?.temporaryId, injuredId: data.driver?.id || '', id: '', temporaryId: `tempId-${v4()}` });
        }
      } else if (!this.isABOnly() && data?.whoDrivingVehicle?.value?.name !== 'Driver not listed' && data?.whoDrivingVehicle?.value?.name !== 'Unoccupied') {
        notInjuredPassengers.push({ firstName: data.whoDrivingVehicle?.value?.firstName, lastName: data.whoDrivingVehicle?.value?.lastName, injuredPolicySystemId: data.whoDrivingVehicle?.value?.policySystemId, injuredId: data.whoDrivingVehicle?.value?.id || '', id: '', temporaryId: `tempId-${v4()}` });
      } else if (!this.isABOnly() && (data?.driver?.firstName?.value || data?.driver?.lastName?.value)) {
        notInjuredPassengers.push({ firstName: data.driver?.firstName?.value, lastName: data.driver?.lastName?.value, injuredTemporaryId: data.driver?.temporaryId, injuredId: data.driver?.id || '', id: '', temporaryId: `tempId-${v4()}` });
      } else if (!this.isABOnly()) {
        notInjuredPassengers.push({ firstName: '', lastName: '', injuredTemporaryId: data.driver?.temporaryId, injuredId: data.driver?.id || '', id: '', temporaryId: `tempId-${v4()}` });
      }
      if (data?.passengers) {
        for (let i = 0; i < data.passengers.addPassengerInfo.length; i += 1) {
          if (data.passengers.addPassengerInfo[i].name.value !== 'No passenger') {
            const isInjured = data.passengers.addPassengerInfo[i].selected && data.passengers.addPassengerInfo[i].isInjured.value;

            let newObj = {};
            if (Object.prototype.hasOwnProperty.call(data.passengers.addPassengerInfo[i], 'policySystemId')) {
              newObj = { firstName: data.passengers.addPassengerInfo[i].firstName, lastName: data.passengers.addPassengerInfo[i].lastName, injuredPolicySystemId: data.passengers.addPassengerInfo[i].policySystemId, injuredId: data.passengers.addPassengerInfo[i].id || '', id: '', temporaryId: `tempId-${v4()}`, ...data.passengers.addPassengerInfo[i] };
            } else {
              newObj = { firstName: data.passengers.addPassengerInfo[i].firstName, lastName: data.passengers.addPassengerInfo[i].lastName, injuredTemporaryId: data.passengers.addPassengerInfo[i].temporaryId, injuredId: data.passengers.addPassengerInfo[i].id || '', id: '', ...data.passengers.addPassengerInfo[i] };
            }

            if (Object.prototype.hasOwnProperty.call(newObj, 'temporaryId')) {
              delete newObj.temporaryId;
            }
            if (isInjured) {
              injuredPassengers.push(newObj);
            } else if (!isInjured) {
              notInjuredPassengers.push(newObj);
            }
          }
        }
      }

      this.setState((prevState) => {
        const tempWhatAreTheInjuriesInfo = [...prevState.value.whatAreTheInjuriesInfo];

        const missingPassengers = injuredPassengers.filter((d) => {
          if (Object.prototype.hasOwnProperty.call(d, 'injuredPolicySystemId') && tempWhatAreTheInjuriesInfo.some((el) => el.injuredPolicySystemId === d.injuredPolicySystemId)) {
            return false;
          } if (Object.prototype.hasOwnProperty.call(d, 'injuredTemporaryId') && tempWhatAreTheInjuriesInfo.some((el) => el.injuredTemporaryId === d.injuredTemporaryId)) {
            return false;
          }
          return true;
        }).map((t) => ({
          ...t,
          id: '',
          temporaryId: `tempId-${v4()}`,
          selectAllInjuriesApply: { selectedValues: [], review: t.firstName !== '' && t.lastName !== '' ? { label: `${t.firstName} ${t.lastName}`, typelist: getTypelist('selectAllInjuriesApply') } : { label: 'Driver', typelist: getTypelist('selectAllInjuriesApply') } },
          selectBonesBroken: { selectedValues: [], review: { label: 'Broken bones', typelist: getTypelist('selectBonesBroken') } },
          followingApply: { selectedValues: [], review: { label: 'Impact', typelist: getTypelist('followingApply') } },
          wereAnyOfTheFollowingItemsDamaged: { selectedValues: [], review: { label: 'Damaged items', typelist: getTypelist('wereAnyOfTheFollowingItemsDamaged') } } }));

        const injuredOnly = tempWhatAreTheInjuriesInfo.filter((d) => {
          let injured = true;
          if (Object.prototype.hasOwnProperty.call(d, 'injuredPolicySystemId')) {
            if (!this.isABOnly()) {
              if (data?.driverIsInjured?.value) {
                if (notInjuredPassengers.some((el) => el.injuredPolicySystemId === d.injuredPolicySystemId) && d.injuredPolicySystemId !== data.whoDrivingVehicle.value.policySystemId) {
                  injured = false;
                }
              } else if (notInjuredPassengers.some((el) => el.injuredPolicySystemId === d.injuredPolicySystemId)) {
                injured = false;
              }
            } else if (notInjuredPassengers.some((el) => el.injuredPolicySystemId === d.injuredPolicySystemId)) {
              injured = false;
            }
          } else if (Object.prototype.hasOwnProperty.call(d, 'injuredTemporaryId') && notInjuredPassengers.some((el) => el.injuredTemporaryId === d.injuredTemporaryId)) {
            injured = false;
          }
          return injured;
        });

        const num1 = injuredOnly ? injuredOnly.length : 0;
        const num2 = missingPassengers ? missingPassengers.length : 0;
        const errors = Array(num1 + num2).fill({ selectAllInjuriesApply: false, selectBonesBroken: false, followingApply: false });

        return {
          value: { whatAreTheInjuriesInfo: [...injuredOnly, ...missingPassengers] }, formErrors: errors };
      }, () => {
      // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }

    setTimeout(() => {
      document.getElementsByClassName('app')[0].scrollTop = 0;
    }, 100);
  }

  setCheckboxValue = (type, index, v) => {
    const { value, formErrors, hasTriggeredError, fatalityModal } = this.state || null;
    const { onChange } = this.props || null;

    if (value && value.whatAreTheInjuriesInfo) {
      if (value.whatAreTheInjuriesInfo[index][type].selectedValues.includes(v)) {
        const newList = [...value.whatAreTheInjuriesInfo];
        newList[index][type].selectedValues = newList[index][type].selectedValues.filter((selectedValue) => selectedValue !== v);

        const { selectedValues } = newList[index].selectAllInjuriesApply;
        if ((selectedValues.length === 0 || selectedValues.length > 2
            || (selectedValues.length === 1 && (!selectedValues.includes('stiffAndSore') && !selectedValues.includes('cutsAndBruises')))
            || (selectedValues.length === 2 && !selectedValues.includes('stiffAndSore') && !selectedValues.includes('cutsAndBruises')))) {
          newList[index].followingApply.selectedValues = [];
        }

        if (!selectedValues.includes('brokenBones')) {
          newList[index].selectBonesBroken.selectedValues = [];
        }

        const errors = [...formErrors];
        errors[index][type] = hasTriggeredError && newList[index][type].selectedValues.length < 1; // show errors if unchecked option was the last one

        const tempFatality = { ...fatalityModal };
        if (type === 'selectAllInjuriesApply' && v === 'lossOfLife') {
          tempFatality.num = fatalityModal.num > 0 ? fatalityModal.num - 1 : 0;
          tempFatality.opened = tempFatality.num > 0;
        }

        this.setState({
          value: {
            whatAreTheInjuriesInfo: newList,
          },
          fatalityModal: tempFatality,
          formErrors: errors,
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      } else {
        const newList = [...value.whatAreTheInjuriesInfo];
        newList[index][type].selectedValues = newList[index][type].selectedValues.length ? [...newList[index][type].selectedValues, v] : [v];

        const errors = [...formErrors];
        errors[index][type] = false; // hide errors because option was checked

        const tempFatality = { ...fatalityModal };
        if (type === 'selectAllInjuriesApply' && v === 'lossOfLife') {
          tempFatality.num = fatalityModal.num + 1;
        }

        this.setState({
          value: {
            whatAreTheInjuriesInfo: newList,
          },
          fatalityModal: tempFatality,
          formErrors: errors,
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      }
    }
  };

  getClaimType() {
    const { data } = this.state;
    if (data.lossCause?.value === 'multi_vehicle') {
      return 'multi_vehicle';
    }
    if (data.lossCause?.value === 'single_vehicle' && data.secLossCause_single_vehicle?.value === 'collisionWithCyclist') {
      return 'collisionWithCyclist';
    }
    if (data.lossCause?.value === 'single_vehicle' && data.secLossCause_single_vehicle?.value === 'collisionWithPedestrian') {
      return 'collisionWithPedestrian';
    }
    if (data.lossCause?.value === 'occupantThirdPartyVehicle') {
      return 'occupantThirdPartyVehicle';
    }
    if (data.lossCause?.value === 'injuredPedestrianOrCyclist') {
      return 'injuredPedestrianOrCyclist';
    }
    return 'undefined';
  }

  // eslint-disable-next-line class-methods-use-this
  dragAndDropHandler = (index, files) => {
    const { value, formErrors, hasTriggeredError } = this.state || null;
    const { onChange } = this.props || null;

    const newList = [...value.whatAreTheInjuriesInfo];
    newList[index].file_damagesPictures = files;

    const errors = [...formErrors];
    errors[index].file_damagesPictures = !!(hasTriggeredError && newList[index].file_damagesPictures?.rejectedFiles?.length);

    this.setState({
      value: {
        whatAreTheInjuriesInfo: newList,
        formErrors: errors,
      },
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  showDynamicField = (type, index) => {
    const { value } = this.state;
    if (value?.whatAreTheInjuriesInfo && value?.whatAreTheInjuriesInfo[index]?.selectAllInjuriesApply?.selectedValues?.length) {
      switch (type) {
        case 'selectBonesBroken':
          return value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.includes('brokenBones');
        case 'followingApply':
          return ((value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.length === 1 && (value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.includes('stiffAndSore') || value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.includes('cutsAndBruises'))) || (value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.length === 2 && value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.includes('stiffAndSore') && value.whatAreTheInjuriesInfo[index].selectAllInjuriesApply.selectedValues.includes('cutsAndBruises')));
        default:
          return false;
      }
    } else {
      return false;
    }
  };

  checked = (type, index, v) => {
    const { value } = this.state;
    if (value?.whatAreTheInjuriesInfo[index][type]?.selectedValues?.length) {
      if (value.whatAreTheInjuriesInfo[index][type].selectedValues.includes(v)) { return true; }
    }
    return false;
  };

  errorHandler = () => {
    const { value } = this.state;
    const { whatAreTheInjuriesInfo } = value;
    const errors = [];
    whatAreTheInjuriesInfo.forEach((element) => {
      const selectAllInjuriesApply = element?.selectAllInjuriesApply?.selectedValues ? element?.selectAllInjuriesApply.selectedValues.length < 1 : false;
      const selectBonesBroken = element?.selectBonesBroken?.selectedValues ? element?.selectBonesBroken.selectedValues.length < 1 : false;
      const followingApply = element?.followingApply?.selectedValues ? element?.followingApply.selectedValues.length < 1 : false;
      const file_damagesPictures = element.file_damagesPictures?.rejectedFiles?.length;
      errors.push({ selectAllInjuriesApply, selectBonesBroken, followingApply, file_damagesPictures });
    });

    this.setState({ hasTriggeredError: true, formErrors: errors });
  };

  isABOnly = () => {
    if (this.getClaimType() === 'occupantThirdPartyVehicle' || this.getClaimType() === 'injuredPedestrianOrCyclist') {
      return true;
    }
    return false;
  };

  render() {
    const { value, thePolicy, formErrors, fatalityModal } = this.state || null;
    const { disabled, component, intl, localParams } = this.props || null;
    const { maxFiles, typeOfFiles, fileMinimumSize, fileMaximumSize, globalErrorMessage, maxFilesErrorMessage, filePattern, maxFilesModalErrorMessage } = component || null;

    return (
      <>
        {value?.whatAreTheInjuriesInfo.length ? value.whatAreTheInjuriesInfo.map((element, index) => (
          <div key={`whatAreTheInjuries_${element.firstName}_${index}`} className="whatAreTheInjuriesContainer">
            <Grid key={index}>
              <Grid.Row>
                <label style={{ marginRight: '3px' }} className="injured-person-label fs-exclude">
                  {(element.firstName || element.lastName)
                    ? intl.formatMessage({ id: 'Tell us about {name} injuries', defaultValue: `Tell us about ${element.firstName} ${element.lastName}'s injuries` }, { name: `${element.firstName} ${element.lastName}` })
                    : intl.formatMessage({ id: 'Tell us about driver\'s injuries', defaultValue: 'Tell us about drivers\'s injuries' })}
                </label>
              </Grid.Row>
              <Grid.Row mt3>
                <label>
                  <FormattedMessage id="Select all that apply" defaultMessage="Select all that apply" />
                </label>
                <div className="injuries-multiple-checkboxes--wrapper">
                  {selectAllInjuriesApplyOptions.map((checkboxIndex) => {
                    const mCheckboxId = `checkbox_${Math.random() * 0xffffffffffff}`;
                    return (
                      <div
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                        tabIndex="0"
                        aria-labelledby={checkboxIndex.value}
                        role="group"
                        id={`div_${mCheckboxId}`}
                        key={`div_key_${mCheckboxId}`}
                        className="injuries-div-multiple-checkboxes"
                      >
                        <input
                          type="checkbox"
                          disabled={disabled}
                          id={mCheckboxId}
                          key={`key_${mCheckboxId}`}
                          className={`injuries-multiple-checkboxes${!this.checked('selectAllInjuriesApply', index, checkboxIndex.value) ? '' : ' injuries-multiple-checkboxes--checked'}`}
                          value={checkboxIndex.value}
                          onChange={(newValue) => this.setCheckboxValue('selectAllInjuriesApply', index, newValue.target.value)}
                          checked={this.checked('selectAllInjuriesApply', index, checkboxIndex.value)}
                        />
                        <label htmlFor={mCheckboxId}>{intl.formatMessage({ id: `${checkboxIndex.label}`, defaultValue: `${checkboxIndex.label}` })}</label>
                      </div>
                    );
                  })}
                </div>
                {formErrors && formErrors[index] && formErrors[index].selectAllInjuriesApply && (
                  <div className="formio-errors invalid-feedback">
                    <div className="form-text error"><FormattedMessage id="Oops! Looks like you forgot to fill this in." defaultMessage="Oops! Looks like you forgot to fill this in." /></div>
                  </div>
                )}
              </Grid.Row>
              {this.showDynamicField('selectBonesBroken', index) ? (
                <Grid.Row mt3>
                  <label>
                    <FormattedMessage id="Which bones were broken?" defaultMessage="Which bones were broken?" />
                  </label>
                  <div className="injuries-multiple-checkboxes--wrapper injuries-smaller-checkboxes">
                    {selectBonesBrokenOptions.map((checkboxIndex) => {
                      const mCheckboxId = `checkbox_${Math.random() * 0xffffffffffff}`;
                      return (
                        <div // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                          tabIndex="0"
                          aria-labelledby={checkboxIndex.value}
                          role="group"
                          id={`div_${mCheckboxId}`}
                          key={`div_key_${mCheckboxId}`}
                          className="injuries-div-multiple-checkboxes"
                        >
                          <input
                            type="checkbox"
                            disabled={disabled}
                            id={mCheckboxId}
                            key={`key_${mCheckboxId}`}
                            className={`injuries-multiple-checkboxes${!this.checked('selectBonesBroken', index, checkboxIndex.value) ? '' : ' injuries-multiple-checkboxes--checked'}`}
                            value={checkboxIndex.value}
                            onChange={(newValue) => this.setCheckboxValue('selectBonesBroken', index, newValue.target.value)}
                            checked={this.checked('selectBonesBroken', index, checkboxIndex.value)}
                          />
                          <label htmlFor={mCheckboxId}>{intl.formatMessage({ id: `${checkboxIndex.label}`, defaultValue: `${checkboxIndex.label}` })}</label>
                        </div>
                      );
                    })}
                  </div>
                  {formErrors && formErrors[index] && formErrors[index].selectBonesBroken && (
                    <div className="formio-errors invalid-feedback">
                      <div className="form-text error"><FormattedMessage id="Oops! Looks like you forgot to fill this in." defaultMessage="Oops! Looks like you forgot to fill this in." /></div>
                    </div>
                  )}
                </Grid.Row>
              ) : null}
              {this.showDynamicField('followingApply', index) ? (
                <Grid.Row mt3>
                  <label>
                    <FormattedMessage id="What were the impact of your injuries?" defaultMessage="What were the impact of your injuries?" />
                  </label>
                  <div className="injuries-multiple-checkboxes--wrapper">
                    {followingApplyOptions.map((checkboxIndex) => {
                      const mCheckboxId = `checkbox_${Math.random() * 0xffffffffffff}`;
                      return (
                        <div // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                          tabIndex="0"
                          aria-labelledby={checkboxIndex.value}
                          role="group"
                          id={`div_${mCheckboxId}`}
                          key={`div_key_${mCheckboxId}`}
                          className="injuries-div-multiple-checkboxes"
                        >
                          <input
                            type="checkbox"
                            disabled={disabled}
                            id={mCheckboxId}
                            key={`key_${mCheckboxId}`}
                            className={`injuries-multiple-checkboxes${!this.checked('followingApply', index, checkboxIndex.value) ? '' : ' injuries-multiple-checkboxes--checked'}`}
                            value={checkboxIndex.value}
                            onChange={(newValue) => this.setCheckboxValue('followingApply', index, newValue.target.value)}
                            checked={this.checked('followingApply', index, checkboxIndex.value)}
                          />
                          <label htmlFor={mCheckboxId}>{intl.formatMessage({ id: `${checkboxIndex.label}`, defaultValue: `${checkboxIndex.label}` })}</label>
                        </div>
                      );
                    })}
                  </div>
                  {formErrors && formErrors[index] && formErrors[index].followingApply && (
                    <div className="formio-errors invalid-feedback">
                      <div className="form-text error"><FormattedMessage id="Oops! Looks like you forgot to fill this in." defaultMessage="Oops! Looks like you forgot to fill this in." /></div>
                    </div>
                  )}
                </Grid.Row>
              ) : null}
              {/* ONTARIO POLICIES ONLY */}
              { thePolicy?.policyProvince === 'Ontario' && (
              <Grid.Row mt3>
                <label>
                  <FormattedMessage id="Were any of these items damaged? (optional)" defaultMessage="Were any of these items damaged? (optional)" />
                </label>
                <div className="injuries-multiple-checkboxes--wrapper injuries-smaller-checkboxes injuries-medium-checkboxes">
                  {wereAnyOfTheFollowingItemsDamagedOptions.map((checkboxIndex) => {
                    const mCheckboxId = `checkbox_${Math.random() * 0xffffffffffff}`;
                    return (
                      <div // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                        tabIndex="0"
                        aria-labelledby={checkboxIndex.value}
                        role="group"
                        id={`div_${mCheckboxId}`}
                        key={`div_key_${mCheckboxId}`}
                        className="injuries-div-multiple-checkboxes"
                      >
                        <input
                          type="checkbox"
                          disabled={disabled}
                          id={mCheckboxId}
                          key={`key_${mCheckboxId}`}
                          className={`injuries-multiple-checkboxes${!this.checked('wereAnyOfTheFollowingItemsDamaged', index, checkboxIndex.value) ? '' : ' injuries-multiple-checkboxes--checked'}`}
                          value={checkboxIndex.value}
                          onChange={(newValue) => this.setCheckboxValue('wereAnyOfTheFollowingItemsDamaged', index, newValue.target.value)}
                          checked={this.checked('wereAnyOfTheFollowingItemsDamaged', index, checkboxIndex.value)}
                        />
                        <label htmlFor={mCheckboxId}>{intl.formatMessage({ id: `${checkboxIndex.label}`, defaultValue: `${checkboxIndex.label}` })}</label>
                      </div>
                    );
                  })}
                </div>
              </Grid.Row>
              ) }
              <Grid.Row mt3>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <label className="label-question">
                    <FormattedMessage id="Upload files or images (optional)" defaultMessage="Upload files or images (optional)" />
                  </label>
                  <Tooltip id="uploadfiles_tooltip" title={intl.formatMessage({ id: 'Uploading files', defaultValue: 'Uploading files' })} primary>
                    <FormattedMessage
                      {...messages.tooltip}
                      values={{
                        videoAudioImageAndTextDocuments: (
                          <a href={intl.formatMessage(messages.videoAudioImageAndTextDocumentsUrl)} target="_blank" rel="noreferrer">
                            {intl.formatMessage(messages.videoAudioImageAndTextDocuments)}
                          </a>
                        ),
                      }}
                    />
                  </Tooltip>
                </div>
                <div className="file-upload-margin">
                  <FormioErrorHandler>
                    <FileUpload
                      index={index}
                      dragAndDrop={this.dragAndDropHandler}
                      value={element.file_damagesPictures || null}
                      maxFiles={maxFiles}
                      filePattern={filePattern}
                      typeOfFiles={typeOfFiles}
                      fileMinimumSize={fileMinimumSize}
                      fileMaximumSize={fileMaximumSize}
                      globalErrorMessage={globalErrorMessage}
                      maxFilesModalErrorMessage={maxFilesModalErrorMessage}
                      maxFilesErrorMessage={maxFilesErrorMessage}
                      localParams={localParams}
                    />
                  </FormioErrorHandler>
                </div>
                {formErrors && formErrors[index] && formErrors[index].file_damagesPictures ? (
                  <div className="formio-errors invalid-feedback" />
                ) : null}
              </Grid.Row>
            </Grid>
          </div>
        )) : null}
        {fatalityModal.num === 1 && !fatalityModal.opened && (
          <FatalityPopUp
            open={!fatalityModal.opened}
            closeFatalityPopUp={() => this.setState({ fatalityModal: { opened: true, num: 1 } })}
          />
        )}
      </>
    );
  }
};

const CustomWhatAreTheInjuriesWithIntl = injectIntl(CustomWhatAreTheInjuries);

export default class WhatAreTheInjuriesComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom WhatAreTheInjuries',
      icon: 'tasks',
      group: 'data',
      documentation: '',
      schema: WhatAreTheInjuriesComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customWhatAreTheInjuries',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomWhatAreTheInjuriesSettings;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomWhatAreTheInjuriesWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          form={this.root?.parent}
          onChange={this.updateValue}
          localParams={localParams}
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
